import TablePagination from '@mui/material/TablePagination'

import { useEffect, useState } from 'react'

import TablePaginationActions from '@/components/Table/Generic/BackofficeTablePagination/TablePaginationActions'

const BackofficeTablePagination = ({
  onPaginationChange,
  total = -1,
  filter = {},
  defaultInitialPage = 0,
  initialRowsPerPage = 10
}) => {
  const [page, setPage] = useState(defaultInitialPage)
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)

  const submit = (page, rowsPerPage) =>
    onPaginationChange({
      from: page * rowsPerPage,
      size: rowsPerPage
    })

  useEffect(() => {
    setPage(defaultInitialPage)
    submit(defaultInitialPage, rowsPerPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  const labelDisplayedRows = ({ from, to, count }) => {
    const total = count === -1 ? `mais que ${to}` : count
    return `${from} - ${to} de ${total}`
  }

  return (
    <TablePagination
      ActionsComponent={TablePaginationActions}
      component="div"
      count={total}
      labelDisplayedRows={labelDisplayedRows}
      labelRowsPerPage={'Resultados por página:'}
      onPageChange={(_, page) => {
        setPage(page)
        submit(page, rowsPerPage)
      }}
      onRowsPerPageChange={(event) => {
        const nextRowsPerPage = Number(event?.target?.value)
        setPage(defaultInitialPage)
        setRowsPerPage(nextRowsPerPage)
        submit(defaultInitialPage, nextRowsPerPage)
      }}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[3, 5, 10, 25, 50, 100]}
    />
  )
}

export default BackofficeTablePagination
